export default "__VITE_ASSET__Cekn42nx__"